import { Toast, Clickable } from '@taxbit-private/cosmic'
import { useEffect, useRef } from 'react'

import useAppStore from 'store/useAppStore'

import { Toast as ToastType } from './notificationSliceModels'

const TimedToast: React.FC<ToastType> = ({
  ctaProps,
  message,
  timeoutMs,
  trackingId,
  uuid,
  variant,
}) => {
  const timeoutRef = useRef<NodeJS.Timeout>()

  const removeCosmicToast = useAppStore((state) => state.removeCosmicToast)

  useEffect(() => {
    if (timeoutMs) {
      timeoutRef.current = setTimeout(() => removeCosmicToast(uuid), timeoutMs)
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [timeoutMs, removeCosmicToast, uuid])

  const ctaElement = (() => {
    if (ctaProps) {
      return <Clickable variant="anchor-primary" {...ctaProps} />
    } else {
      return undefined
    }
  })()

  return (
    <Toast
      key={uuid}
      onClose={() => removeCosmicToast(uuid)}
      variant={variant}
      trackingId={trackingId ?? ''}
    >
      {message} {ctaElement}
      {/* Per design guidelines, toast messages are complete sentences. */}
      {ctaElement ? '.' : ''}
    </Toast>
  )
}

export default TimedToast
